module.exports = __webpack_public_path__ + "images/for_company_page/point1-site_f029305697e4fb1858d40458bac1bfe1.png";